<template>
  <main>
    <section class="section">
      <div class="container">
        <div class="section__block">
          <h1 class="text-center mb-5 headline--underlined">Aktuelles</h1>
        </div>
        <div class="section__block">
          <div class="row justify-content-center">
            <div v-for="newsItem in mainNews" :key="newsItem.id" class="col-12 col-md-6 col-lg-4">
              <div
                  class="card"
                  :style="{ backgroundColor: newsItem.backgroundColor ? 'var(' + newsItem.backgroundColor + ')' : '' }"
              >
                <figure v-if="imageSrc(newsItem)">
                  <img class="card-img-top" :src="imageSrc(newsItem)" alt="Card image"/>
                </figure>
                <div class="card-body">
                  <h3 class="card-title">{{ newsItem.title }}</h3>
                  <p class="card-text">{{ newsItem.text }}</p>
                  <router-link :to="{ name: 'focusNews', params: {id: newsItem.id}}"
                               class="card__link link link--internal">weiterlesen
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>

import {onMounted, ref, computed} from "vue";
import axios from 'axios';

export default {
  setup() {

    const mainNews = ref([]);

    const fetchData = async () => {
      try {
        const response = await axios.get('http://localhost:8082/gemeinde/news/news-all-by-clubid/1');
        mainNews.value = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    onMounted(() => {
      fetchData()
    })

    // Computed Property für das Bild
    const imageSrc = computed(() => (newsItem) => {
      return newsItem.imageName
          ? 'http://localhost:8082/' + newsItem.imageName.split('/').pop()
          : new URL('@/assets/images/news-placeholder.png', import.meta.url).href;
    });

    return {
      mainNews,
      imageSrc
    };
  }
}
</script>

<style></style>
